<template>
  <div>
    <app-header></app-header>
    <div class="container-fluid admin-dashboard">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <app-admin-sidebar></app-admin-sidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div :style="{ margin:'80px' }">
                <div class="float-right">
                  <button type="button" class="btn btn-primary" :disabled="isDisabled" @click="exportSalesTax()">Export<i class="fas fa-spinner fa-spin" v-if="isDisabled"></i></button>
                </div><br>
                <!-- Table Top Start -->
                <div class="d-flex mt-3" style="align-items:center;">
                    <div style="flex-grow:1;" class="pl-2">
                        <form class="form-inline">
                          <div class="form-group mb-2">
                            <input type="text" class="form-control" placeholder="Zipcode" v-model="zipcode">
                          </div>&nbsp;
                          <div class="form-group mb-2">
                            <input type="text" class="form-control" placeholder="State Like AL Or AR" v-model="state">
                          </div>
                          <button type="button" class="btn btn-primary mb-2" @click="getSalesTaxList()">Search</button>
                        </form>
                      </div>
                    <div class="form-group form-inline pr-2">
                        <span class="mr-1">Show </span>
                        <select v-model="PageSize" class="form-control">
                            <option :value="5">5</option>
                            <option :value="10">10</option>
                            <option :value="20">20</option>
                            <option :value="50">50</option>
                        </select>
                        <span class="ml-1"> entries</span>
                    </div>
                </div>
                <div class="spinner-border" v-if="showLoader"></div>
                <!-- Table Top End -->
                <!--  Table Start -->
                <table class="table table-hover table-striped mb-2" v-else>
                    <thead>
                    <tr>
                        <th style="width: 10%;">State</th>
                        <th style="width: 10%;">Zipcode</th>
                        <th style="width: 10%;">Region</th>
                        <th style="width: 10%;">Sales Tax</th>
                        <th style="width: 10%;">State Rate</th>
                        <th style="width: 10%;">County Rate</th>
                        <th style="width: 10%;">City Rate</th>
                        <th style="width: 10%;">Special Rate</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in tableData" :key="item.id">
                        <td>{{ item.state }}</td>
                        <td>{{ item.zipcode }}</td>
                        <td>{{ item.tax_region_name }}</td>
                        <td>{{ parseFloat(item.sales_tax).toFixed(3) }}</td>
                        <td>{{ parseFloat(item.state_rate).toFixed(3) }}</td>
                        <td>{{ parseFloat(item.county_rate).toFixed(3) }}</td>
                        <td>{{ parseFloat(item.city_rate).toFixed(3) }}</td>
                        <td>{{ parseFloat(item.special_rate).toFixed(3) }}</td>
                    </tr>
                    </tbody>
                </table>
                <!--  Table End -->
                <!-- Page Number Start -->
                <div class="d-flex mb-2" style="align-items: center;">
                    <div style="flex-grow: 1;" class="pl-2">
                    <p>
                        Showing {{ (PageNumber - 1) * PageSize + 1 }} to {{ UpperLimit }}
                        of {{ TotalRecords }} entries
                    </p>
                    </div>
                    <div class="pr-2">
                    <Pagination
                    :data="tableData"
                    :totalPages="Math.ceil(TotalRecords / PageSize)"
                    :total="TotalRecords"
                    :perPage="PageSize"
                    :currentPage="PageNumber"
                    @pagechanged="onTablePageChange"
                    />
                    </div>
                </div>
                <!-- Page Number End-->
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardService from "../../services/DashboardService"
import Pagination from "../../components/Pagination.vue";
import Header from "@/components/Header.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: 'BreakageTransactionHistory',
  components: {
    appHeader: Header,
    appAdminSidebar: divvyAdminSidebar,
    Pagination,
  },
  data() {
    return {
        PageSize: 10,
        PageNumber: 1,
        TotalRecords: 0,
        UpperLimit:0,
        tableData:[],
        zipcode:"",
        state:"",
        showLoader: false,
        isDisabled: false,
    }
  },
  methods: {
    getSalesTaxList() {
      this.showLoader = true;
      let data = { pageSize: this.PageSize, page: this.PageNumber, zipcode: this.zipcode, state: this.state }
      DashboardService.getSalesTaxList(data)
        .then((response) => {
          this.showLoader = false;
          this.tableData = response.data.data.data;
          this.TotalRecords = response.data.data.total;
          this.UpperLimit = this.TotalRecords < this.PageNumber * this.PageSize ? this.TotalRecords : this.PageNumber * this.PageSize;
        })
        .catch((e) => {
          this.showLoader = false;
        });
    },
    exportSalesTax() {
        let data = { zipcode: this.zipcode, state: this.state }
        this.isDisabled =true;
        DashboardService.exportSalesTax(data)
          .then((response) => {
            this.isDisabled =false;
            window.location.href = response.data.data;
          })
          .catch((e) => {
            this.isDisabled =false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },
    onTablePageChange(page) {
      this.PageNumber = page;
      try {
        this.getSalesTaxList();
      } catch (error) {
        console.log(error);
      }
      window.scrollTo(0, 0);
    },
  },
  watch: {
    PageSize() {
      this.PageNumber = 1;
      this.getSalesTaxList();
    }
  },
  beforeMount() {
    this.getSalesTaxList();
  },
}
</script>
